"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasInvalidPolicies = void 0;
const hasInvalidPolicySections_1 = require("./hasInvalidPolicySections");
const hasInvalidPolicies = (policies) => {
    const invalidPolicies = [];
    let invalidSections = [];
    invalidSections = (0, hasInvalidPolicySections_1.hasInvalidPolicySections)(policies);
    if (invalidSections.length > 0)
        invalidPolicies.push(`You have ${invalidSections.length} invalid policies: ${invalidSections.join(", ")}`);
    if (policies?.caddies?.enabled === "YES" && policies?.caddies?.policy === "")
        invalidPolicies.push("You have an invalid caddie policy");
    if (policies?.carts?.enabled === "YES" &&
        policies?.carts?.single_carts &&
        policies?.carts?.policy === "")
        invalidPolicies.push("You have an invalid single cart policy");
    if (policies?.carts?.enabled === "YES" &&
        policies?.carts?.shared_carts &&
        (policies?.carts?.policy === "" || policies?.carts?.odd_no_surcharge === ""))
        invalidPolicies.push("You have an invalid shared cart policy");
    if (policies?.advance_booking?.enabled === "YES" &&
        (!policies?.advance_booking?.weekday ||
            !policies?.advance_booking?.weekend_ph))
        invalidPolicies.push("You have an invalid advance booking policy");
    if (policies?.cancellation?.enabled === "YES" &&
        policies?.cancellation?.config?.length === 0)
        invalidPolicies.push("You have an invalid cancellation policy");
    if (policies?.raincheck?.enabled === "YES" &&
        policies?.raincheck?.config?.en === "")
        invalidPolicies.push("You have an invalid raincheck policy");
    if (policies?.handicap_requirements?.enabled === "YES" &&
        (policies?.handicap_requirements?.certificate_required === "" ||
            policies?.handicap_requirements?.female_handicap === "" ||
            policies?.handicap_requirements?.male_handicap === ""))
        invalidPolicies.push("You have an invalid handicap policy");
    if (policies?.identity_requirement?.enabled === "YES" &&
        (policies?.identity_requirement?.golfname_required === "" ||
            policies?.identity_requirement?.passport_required === "" ||
            policies?.identity_requirement?.nationality_required === "" ||
            policies?.identity_requirement?.when_required === ""))
        invalidPolicies.push("You have an invalid identity policy");
    if (policies?.nationality_restriction?.enabled === "YES" &&
        policies?.nationality_restriction?.config?.length === 0)
        invalidPolicies.push("You have an invalid nationality restriction policy");
    if (policies?.non_playing_followers?.enabled === "YES" &&
        policies?.non_playing_followers?.prices?.length === 0)
        invalidPolicies.push("You have an invalid non playing follower policy");
    return invalidPolicies;
};
exports.hasInvalidPolicies = hasInvalidPolicies;
